import type { DesignElement } from '@/types/blocks'

/** HTML абзаца без тегов: легаси-данные несут `<p></p>`, а не пустую строку. */
const blankHtml = (v: string | null | undefined): boolean =>
  !(v ?? '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim()

/**
 * Есть ли у элемента составного блока пустой текст на этом языке. Новые элементы
 * создаются пустыми (подсказку рисует холст), поэтому незаполненный элемент
 * обязан ловиться здесь, а не уезжать ученику пустым местом. Таблицу
 * проверяет `hasEmptyTableCell` — у неё своя строка в списке.
 */
export const hasEmptyDesignText = (el: DesignElement, en: boolean): boolean => {
  switch (el.type) {
    case 'heading':
    case 'text':
      return blankHtml(en ? el.contentEn : el.content)
    case 'badge':
      return (el.badges ?? []).some((b) => blankHtml(en ? b.textEn : b.text))
    default:
      return false
  }
}

/**
 * Есть ли в таблице незаполненная ячейка на этом языке. Пустая ячейка ученику
 * видна бледным прочерком и читается как недоделка — таблицу просим заполнить
 * до конца (решение заказчика), в том числе таблицу, где пусто всё.
 */
export const hasEmptyTableCell = (el: DesignElement, en: boolean): boolean =>
  el.type === 'table' &&
  (el.tableData ?? []).some((row) => row.some((c) => blankHtml(en ? c.contentEn : c.content)))
